<template>
  <div class="container product-list-wrapper" v-if="productList.length > 0">
    <div class="title-wrapper">
      <div class="title-space">
        <h2 class="h2-bigger" style="margin-bottom: 15px;">Produtos para você representar ou vender em destaque</h2>
        <div class="hr-yellow hr-45"></div>
      </div>
      <button class="border" @click="registerProduct">Cadastre seus produtos</button>
    </div>
    <br><br><br>
    <div class="row product-list hide-mobile">
      <div class="col-md-3" v-for="product of productList" :key="product._id">
        <ProductItem :product="product" :type="0">
        </ProductItem>
      </div>

      <div class="col-md-12" style="text-align: center;" v-if="canLoadMore">
        <button class="border border-bigger" @click="loadMore()">Carregar mais produtos</button>

      </div>
    </div>

    <div class="row product-list only-mobile">
      <div class="col-md-3" v-for="product of productListMobile" :key="product._id">
        <ProductItem :product="product" :type="0">
        </ProductItem>
      </div>

      <div class="col-md-12" style="text-align: center;" v-if="canLoadMore">
        <button class="border border-bigger" @click="loadMore(true)">Carregar mais produtos</button>

      </div>
    </div>
  </div>
</template>

<script>
import { server, local } from "../js/variables.js";
import ProductItem from "./ProductItem.vue";
import userMixin from "../mixins/userMixin.js";

export default {
  mixins: [userMixin],
  components: {
    ProductItem,
  },
  data() {
    return {
      productList: [],
      productListMobile: [],
      endpoint: "/api/product",
      maxItems: 4,
      pageItems: 4,
      maxItemsMobile: 1,
      pageItemsMobile: 1,
      page: 0,
      canLoadMore: true,

    };
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    loadMore(isMobile) {
      if (isMobile) {
        this.maxItemsMobile = this.maxItemsMobile + this.pageItemsMobile;
        this.page = this.page + 1;
        this.loadProducts(true);
      } else {
        this.maxItems = this.maxItems + this.pageItems;
        this.page = this.page + 1;
        this.loadProducts();
      }
    },
    loadProducts(isMobile) {
      let self = this;
      let limit = isMobile ? this.pageItemsMobile : this.pageItems

      let header = JSON.parse(JSON.stringify(server.config));
      header["params"] = {
        limit: limit,
        page: this.page,
        visible: 1,
        approved: 1,
      };

      this.axios
        .get(server.url + this.endpoint, header)
        .then(function (response) {
          let responseData = response.data.data;
          if (self.page == 0) {
            self.productList = [];
            self.productListMobile = [];
          }

          if (responseData.product_list.length > 0) {
            self.productList = responseData.product_list
            self.productListMobile = responseData.product_list.slice(0, self.pageItemsMobile)
          }

          if (responseData.product_list.length != limit) {
            self.canLoadMore = false;
          } else {
            self.canLoadMore = true;
          }
        })
        .catch(function (error) {
          self.output = error;
          self.showError(error);
        });
    },
    registerProduct() {
      if (!localStorage.token) {
        this.goTo('./co/cadastro');
        // $('#loginModal').modal('show');
        return
      }
      if (this.user.type == 'EMPLOYEE') {
        this.$router.push('/co/catalogo')
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Entre como empresa para cadastrar produtos.',
          // footer: '<a href>Why do I have this issue?</a>'
          showCancelButton: false,
          confirmButtonColor: '#053360',
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
            // window.open("./co/vagas", "_self"); 
          }
        })
        return
      }
    },

  }
};
</script>

<style lang="scss">
.product-list-wrapper {
  padding: 30px 0px;

  .title-wrapper {
    display: flex;
    flex-flow: row wrap;

    >div {
      flex: 1;
    }
  }

  .border {
    height: 40px;
    width: 250px;
    border-radius: 12px;

    &-bigger {
      height: 50px;
      width: 300px;
      font-size: 18px;
      margin-top: 40px;
    }
  }

  .product-list {}

}


@media only screen and (max-width: 600px) {

  .product-list-wrapper {

    .title-wrapper {
      padding: 0px 15px;

      .border {
        margin-top: 15px;
        width: 100%;
      }
    }

  }

}
</style>